var _rect, _line, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7292,
    y: 4.89579,
    width: 21.5417,
    height: 35.25,
    rx: 4.89583,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.7085,
    y1: 18.6043,
    x2: 33.2918,
    y2: 18.6043,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1561,
    y: 12.2395,
    width: 0.979167,
    height: 2.9375,
    rx: 0.489583,
    stroke: "#1C1C1C",
    strokeWidth: 0.979167
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1561,
    y: 22.0311,
    width: 0.979167,
    height: 2.9375,
    rx: 0.489583,
    stroke: "#1C1C1C",
    strokeWidth: 0.979167
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1561,
    y: 39.6561,
    width: 0.979167,
    height: 2.9375,
    rx: 0.489583,
    stroke: "#1C1C1C",
    strokeWidth: 0.979167
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8646,
    y: 39.6561,
    width: 0.979167,
    height: 2.9375,
    rx: 0.489583,
    stroke: "#1C1C1C",
    strokeWidth: 0.979167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridge);
export default __webpack_public_path__ + "static/media/fridge.41f116aab827d479afb4608aa5c9cf82.svg";
export { ForwardRef as ReactComponent };